
import { CardBrandData, CardBrandConfig } from '../webgiving-generated';

export function getCardBrandByInput(input: string) {
	for (let b of CardBrandData) {
		if (b.pattern.test(input)) {
			return b;
		}
	}
	return null;
}

export function getCardBrandByKey(key: string) {
	for (let b of CardBrandData) {
		if (b.key === key) {
			return b;
		}
	}

	return null;
}

export function getCardBrandsFromKeys(brandKeys: string[]) {
	return brandKeys.map(getCardBrandByKey).filter(x => x) as CardBrandConfig[];
}
